// extracted by mini-css-extract-plugin
export default {"form":"ActivityLogDialog_form__n60O7"};